import React from "react";
import { Link } from "react-router-dom";

const EditCourseContent = () => {
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Edit Course Content</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Chapter Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter chapter name"
              />
            </div>
          </div>
          <button className="Button">Add Chapter</button>
          <div className="TableList mt-4">
            <table className="table-hover">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Chapter Id</th>
                  <th>Chapter Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>001</td>
                  <td>C-140</td>
                  <td>Introduction</td>
                  <td>
                    <div className="Actions">
                      <Link to={"/courses/editLecture"} className="Edit">
                        <i className="fa-regular fa-pen-to-square" />
                      </Link>
                      <a
                        className="Delete"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#CourseContentDelete"
                      >
                        <i className="fa-regular fa-trash-can" />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>001</td>
                  <td>C-140</td>
                  <td>Introduction</td>
                  <td>
                    <div className="Actions">
                      <a className="Edit" href="add-lecture-edit.html">
                        <i className="fa-regular fa-pen-to-square" />
                      </a>
                      <a
                        className="Delete"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#CourseContentDelete"
                      >
                        <i className="fa-regular fa-trash-can" />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>001</td>
                  <td>C-140</td>
                  <td>Introduction</td>
                  <td>
                    <div className="Actions">
                      <a className="Edit" href="add-lecture-edit.html">
                        <i className="fa-regular fa-pen-to-square" />
                      </a>
                      <a
                        className="Delete"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#CourseContentDelete"
                      >
                        <i className="fa-regular fa-trash-can" />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>001</td>
                  <td>C-140</td>
                  <td>Introduction</td>
                  <td>
                    <div className="Actions">
                      <a className="Edit" href="add-lecture-edit.html">
                        <i className="fa-regular fa-pen-to-square" />
                      </a>
                      <a
                        className="Delete"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#CourseContentDelete"
                      >
                        <i className="fa-regular fa-trash-can" />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>001</td>
                  <td>C-140</td>
                  <td>Introduction</td>
                  <td>
                    <div className="Actions">
                      <a className="Edit" href="add-lecture-edit.html">
                        <i className="fa-regular fa-pen-to-square" />
                      </a>
                      <a
                        className="Delete"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#CourseContentDelete"
                      >
                        <i className="fa-regular fa-trash-can" />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>001</td>
                  <td>C-140</td>
                  <td>Introduction</td>
                  <td>
                    <div className="Actions">
                      <a className="Edit" href="add-lecture-edit.html">
                        <i className="fa-regular fa-pen-to-square" />
                      </a>
                      <a
                        className="Delete"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#CourseContentDelete"
                      >
                        <i className="fa-regular fa-trash-can" />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>001</td>
                  <td>C-140</td>
                  <td>Introduction</td>
                  <td>
                    <div className="Actions">
                      <a className="Edit" href="add-lecture-edit.html">
                        <i className="fa-regular fa-pen-to-square" />
                      </a>
                      <a
                        className="Delete"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#CourseContentDelete"
                      >
                        <i className="fa-regular fa-trash-can" />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>001</td>
                  <td>C-140</td>
                  <td>Introduction</td>
                  <td>
                    <div className="Actions">
                      <a
                        className="Edit"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#EditChapter"
                      >
                        <i className="fa-regular fa-pen-to-square" />
                      </a>
                      <a
                        className="Delete"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#CourseContentDelete"
                      >
                        <i className="fa-regular fa-trash-can" />
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Pagination mb-5">
            <p>Showing 1 to 10 of 97 results</p>
            <ul>
              <li>
                <a href="javascript:void(0);">
                  <i className="fa fa-angle-left" />
                </a>
              </li>
              <li>
                <a href="javascript:void(0);">1</a>
              </li>
              <li className="active">
                <a href="javascript:void(0);">2</a>
              </li>
              <li>
                <a href="javascript:void(0);">3</a>
              </li>
              <li>
                <a href="javascript:void(0);">4</a>
              </li>
              <li>
                <a href="javascript:void(0);">...</a>
              </li>
              <li>
                <a href="javascript:void(0);">20</a>
              </li>
              <li>
                <a href="javascript:void(0);">21</a>
              </li>
              <li>
                <a href="javascript:void(0);">
                  <i className="fa fa-angle-right" />
                </a>
              </li>
            </ul>
          </div>
          <button className="Button Discard">Discard</button>
          <a href="javascript:void(0);" className="Button">
            Save &amp; Next
          </a>
        </div>
      </div>
    </div>
  );
};

export default EditCourseContent;
